import { useEffect, useState } from "react";
import "../styles/homepage.css";
import Sponsors from "./Sponsors/Sponsors";
import Facts from "./Facts/Facts";

  const eventDate = new Date("2026-04-08T00:00:00");

const getTagline = () => {
  const now = new Date();
  const diff = eventDate - now;

  if (diff <= 0) return "TODAY is the day!";

  const totalMinutes = Math.floor(diff / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  if (days === 0 && hours === 0) {
    return `${minutes} minute${minutes !== 1 ? "s" : ""} to go!`;
  }

  if (days === 0) {
    return `${hours} hour${hours !== 1 ? "s" : ""} and ${minutes} minute${minutes !== 1 ? "s" : ""} to go!`;
  }

  return `${days} day${days !== 1 ? "s" : ""}, ${hours} hour${hours !== 1 ? "s" : ""} to go!`;
};

function Countdown() {


  const [tagline, setTagline] = useState(getTagline());

  useEffect(() => {
    const timer = setInterval(() => setTagline(getTagline()), 60000);
    return () => clearInterval(timer);
  }, []);

  if (!tagline) return null;

  return (
    <div className="countdown-banner">
      <span className="countdown-tagline">{tagline}</span>
      <span className="countdown-date">April 8, 2026</span>
    </div>
  );
}

export default function Home() {
  return (
    <div className="homepage" id="homepage">

      {/* Section 1: Countdown + Intro — one 100vh */}
      <div className="snap-section">
        <Countdown />
        <div className="row1">
          <div className="column1">
            <h1>
              <span className="green">BRODKAST </span>
              <span className="white">NG TALINO </span>
              <span className="green">2026</span>
            </h1>
            <p>
              <b>Brodkast ng Talino</b> is an <b>Annual National Inter-Collegiate Electronic Systems and Technologies Quiz Show</b> organized by the Organization of Electronics Engineering Students (OECES) of the Technological University of the Philippines – Manila. Since its inception, Brodkast ng Talino has consistently gathered the brightest minds among Electronics Engineering students from various colleges and universities across the Philippines, fostering excellence in the field of Electronics and Communications Engineering.
            </p>
          </div>
          <div className="column2">
            <img src="pics/bnt.png" alt="Brodkast ng Talino Logo" className="bnt-img" />
          </div>
        </div>
      </div>

      {/* Section 2: Theme + OECES */}
      <div className="snap-section">
        <div className="rows-combined">
          <div className="column">
            <p>
              This year, Brodkast ng Talino elevates its legacy with its 11th edition, with a theme <b>"OVERTONE: Ascending to Greater Frequencies of Brilliance."</b> Building upon years of pioneering excellence, this edition transcends conventional competition in a fiercely engaging buzzer battle where contestants ignite a rapid-fire race of minds. Every buzz is a burst of intellect, and every answer propels them closer to victory. Engineered for those who think at the speed of brilliance. The competition is open to all bona fide undergraduate students of Electronics Engineering from any recognized college or university in the Philippines.
            </p>
          </div>
          <div className="column2">
            <img src="pics/oeces.png" alt="OECES Logo" className="oeces-img" />
          </div>
          <div className="column1">
            <p>
              The OECES is proud <b>to continue this tradition of promoting academic excellence and innovation</b>. Brodkast ng Talino serves as a platform not only to showcase technical expertise but also to inspire camaraderie and collaboration among future leaders in Electronics Systems and Technologies. <b>By participating in this event, students remain attuned to the latest technological advancements and share their knowledge with peers, contributing to the collective progress of the field in the modern era.</b>
            </p>
          </div>
        </div>
      </div>

      {/* Section 3: Handbook & Primer */}
      <div className="snap-section">
        <div className="resources-section">
          <h2 className="resources-title">
            <span className="green">Official Handbook and Partnership Primer</span>
          </h2>
          <p className="resources-subtitle">Your complete guide to rules, partnerships, and everything in between.</p>
          <div className="resources-cards">
            <a href="../docs/BNT 2026 HandBook.pdf" className="resource-card" target="_blank" rel="noopener noreferrer">
              <div className="resource-icon">📋</div>
              <div className="resource-info">
                <span className="resource-name">Official Handbook</span>
                <span className="resource-desc">Rules, mechanics, and competition guidelines</span>
              </div>
              <span className="resource-arrow">↗</span>
            </a>
            <a href="../docs/Brodkast ng Talino 2026 Partnership Primer.pdf" className="resource-card" target="_blank" rel="noopener noreferrer">
              <div className="resource-icon">📖</div>
              <div className="resource-info">
                <span className="resource-name">Partnership Primer</span>
                <span className="resource-desc">Official partnership tiers, benefits, and sponsorship details</span>
              </div>
              <span className="resource-arrow">↗</span>
            </a>
          </div>
        </div>
      </div>

      <div className="snap-section"><Facts /></div>
      <div className="snap-section"><Sponsors /></div>

    </div>
  );
}